// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { seiDevnet as _seiDevnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the seiDevnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 713715
 * Chain Name: Sei Devnet
 * Default Block Explorer: https://seitrace.com
 * Default RPC URL: https://evm-rpc-arctic-1.sei-apis.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { seiDevnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: seiDevnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const seiDevnet = createCommon({
	..._seiDevnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
